import { useCallback, useEffect } from 'react';
var useEscapeKey = function useEscapeKey(onEscape) {
  var handleKeyDown = useCallback(function (event) {
    if (event.key === 'Escape') {
      // Check if the active element is an input or textarea
      var _document = document,
        activeElement = _document.activeElement;
      if ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'INPUT' || (activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'TEXTAREA') {
        // If focused on an input or textarea, stop propagation
        event.stopPropagation();
        activeElement.blur(); // Optionally blur the input
      } else {
        // If not focused on an input, call the onEscape handler
        onEscape === null || onEscape === void 0 || onEscape();
      }
    }
  }, [onEscape]);
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};
export default useEscapeKey;